import { useEffect, useState } from 'react'
import { fetchOrderStats, fetchProjectStats, type StatRow } from '../../../Repository/Admin/AdminStatsRepository.js'

/** Loads the order + project stats feeds; shared by the overview and single-metric pages. */
export const useStatsData = (excludeInternal: boolean) => {
  const [orders, setOrders] = useState<StatRow[]>([])
  const [projects, setProjects] = useState<StatRow[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(null)
    Promise.all([fetchOrderStats(excludeInternal), fetchProjectStats(excludeInternal)])
      .then(([o, p]) => {
        if (cancelled) return
        setOrders(o)
        setProjects(p)
      })
      .catch((e) => {
        if (!cancelled) setError(e instanceof Error ? e.message : 'Failed to load stats')
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [excludeInternal])

  return { orders, projects, loading, error }
}
